export default "__VITE_ASSET__dee10b0b__"